/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <!-- 内容区域 -->
      <div class="onlinesystempage" ref="onlinesystem" :style="{ height: bodyHeight + 'px' }">
        <!-- 左边区域 -->
        <div class="leftbox" :style="{ height: bodyHeight + 'px' }">
          <div class="linehr"></div>
          <!-- 搜索 -->
          <div class="searchbox">
            <Input
              style="width: 90%; flex: none"
              @on-enter="getTreeInfo"
              v-model="seachCName"
              class="tabdiv"
              placeholder="搜索街道或企业"
            >
              <span slot="append" @click="getTreeInfo(seachCName)"><Icon type="ios-search-outline" /></span>
            </Input>
            <Spin v-if="treeLoading" fix>
              <Icon type="ios-loading" size="18" class="demo-spin-icon-load" />
              <div>加载中...</div>
            </Spin>
          </div>

          <div class="treedivbox">
            <el-tree
              ref="treeBox"
              node-key="keyID"
              :data="treeData"
              :default-expanded-keys="expandedKeys"
              :props="defaultProps"
              :highlight-current="true"
              :render-content="renderContent"
              @node-click="handleNodeClick"
            />
          </div>
        </div>
        <!-- 右边区域 -->
        <div class="rightbox" :style="{ height: bodyHeight + 'px' }">
          <div class="gsname">{{ companyName || '' }}</div>
          <Tabs v-model="activeTab" type="card">
            <TabPane label="分钟数据" icon="ios-timer" name="1">
              <div style="height: 16px; background: #fff"></div>
              <minuteData
                :companyTime="createTime"
                :company_id="companyId"
                :gkSiteId="gkSite_id"
                ref="minuteTime"
              ></minuteData>
            </TabPane>
            <TabPane label="小时数据" icon="md-clock" name="2">
              <div style="height: 16px; background: #fff"></div>
              <timeData
                :companyTime="createTime"
                :company_id="companyId"
                ref="hoursTime"
                :gkSiteId="gkSite_id"
              ></timeData>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </X-Layout>
  </div>
</template>

<script>
import tableLine from '@/pages/echartsTable/table-line';
import 'element-ui/lib/theme-chalk/index.css';
import { mathEleHeight } from '@/utils/common';
import { parseTime } from '@/utils/date';
import { downfile, formatDateTime2, formatDateTime1, formatDateTime3 } from '@/common/common.js';
// 小时
import timeData from './components/timeData.vue';
// 分钟
import minuteData from './components/minuteData.vue';
export default {
  components: {
    tableLine,
    timeData,
    minuteData,
  },
  data() {
    return {
      createTime: '', // 公司创建时间
      companyId: '', // 被选中的公司id
      bodyHeight: '', // 主框的高度
      activeTab: '1',
      companyName: '', // 公司名
      clickFlag: 0, // 判断点击的是不是当前的数据
      defaultProps: {
        // 设置树菜单的接受格式
        children: 'childrens',
        label: 'title',
      },
      expandedKeys: [], // 指定树菜单展开key
      treeData: [], // 树菜单数据
      treeLoading: false, // 树菜单加载动画

      comids: '',
      gkSite_id: '', // 排口id
      seachCName: '', // 搜索企业名
    };
  },
  beforeDestroy() {
    clearInterval(this.$refs.minuteTime.dayTableTime);
    clearInterval(this.$refs.hoursTime.dayTableTime);
  },
  destroyed() {
    window.onresize = '';
  },
  mounted() {
    this.$nextTick(() => {
      this.getBodyHeight();
    });
    this.comids = this.$route.params.id ? this.$route.params.id : null; // 有传入公司ID
    this.getTreeInfo(); // 执行初始化树菜单

    window.onresize = () => {
      if (this.$refs.minuteTime.echart) {
        this.$refs.minuteTime.echart.resize();
      }

      if (this.$refs.hoursTime.echart) {
        this.$refs.hoursTime.echart.resize();
      }
      this.getBodyHeight();
    };
  },

  methods: {
    getBodyHeight() {
      this.bodyHeight = mathEleHeight(this.$refs.onlinesystem, 20);
    },
    /**
     * 树菜单使用的render 使用自定义格式 返回对应的样式
     */
    renderContent: function (h, { node, data, store }) {
      switch (
        data.level // 判断树菜单层级
      ) {
        case 1: // 第1层 街道显示数量 报警变色
          if (data.streetStatus === 1 || data.streetStatus === 2) {
            return (
              <span style="font-size: 14px;color:red;">
                {' '}
                <i class={data.icon}> </i> <span style="padding-left: 4px;"> {node.label} </span> <span> </span>{' '}
              </span>
            );
          } else {
            return (
              <span style="font-size: 14px">
                {' '}
                <i class={data.icon}> </i> <span style="padding-left: 4px;"> {node.label} </span>{' '}
              </span>
            );
          }
        case 2: // 第2层 公司需要显示数量 报警变色
          if (data.warnStatus === 1) {
            // 判断公司报警状态
            return (
              <span style="font-size: 14px;color:red;">
                {' '}
                <i class={data.icon}> </i>
                <Badge count={data.num1}>
                  <span style="padding-left: 4px;">{node.label}</span>
                </Badge>
              </span>
            );
          } else {
            return (
              <span style="font-size: 14px;">
                {' '}
                <i class={data.icon}> </i> <span style="padding-left: 4px;"> {node.label} </span>{' '}
              </span>
            );
          }
        case 3: // 第3层 排口不需要显示数量 报警变色
          if (data.status === 1 || data.status === 2) {
            // 判断排口报警状态
            return (
              <span style="font-size: 14px;color:red;">
                {' '}
                <i class={data.icon}> </i> <span style="padding-left: 4px;"> {node.label} </span>{' '}
              </span>
            );
          } else {
            return (
              <span style="font-size: 14px;">
                {' '}
                <i class={data.icon}> </i> <span style="padding-left: 4px;"> {node.label} </span>{' '}
              </span>
            );
          }
      }
    },
    /**
     * 渲染树菜单 根据树菜单要求处理传入得到list数据
     */
    handleTreeList(list) {
      const _warrSite_ids = []; // 用于记录传入公司id时 记录所有报警排口的id集合
      const compayNameList = []; // 记录公司名
      // 处理得到数据 添加上树菜单需要的字段
      for (let i = 0; i < list.length; i++) {
        // 添加1级数菜单 【街道】
        list[i].title = list[i].street_name; // 新添title字段 树菜单显示标题
        list[i].icon = 'icon iconfont icon-quyu'; // 新添icon字段 街道图标
        list[i].level = 1; // 添加层级 当前第1层 用于点击事件判断用
        list[i].keyID = '1' + list[i].street_id; // 添加一个唯一ID 用于展开使用 ；  '1'+ 是为了 1层、2层、3层没有相同的ID
        list[i].childrens = list[i].companylist; // 添加用于树菜单的childrens子级名

        // 处理2级菜单 判断一下是否有childrens节点
        if (list[i].childrens) {
          // 循环第二级数据 添加数据 【公司】
          for (let j = 0; j < list[i].childrens.length; j++) {
            list[i].childrens[j].title = list[i].childrens[j].company_name; // 新添title字段 树菜单显示标题
            list[i].childrens[j].icon = 'icon iconfont icon-jiudian'; // 新添icon字段 企业图标
            list[i].childrens[j].level = 2; // 添加层级 当前第1层 用于点击事件判断用
            list[i].childrens[j].keyID = '2' + list[i].childrens[j].company_id; // 添加一个唯一ID 用于展开使用 ；  '2'+ 是为了  1层、2层、3层没有相同的ID
            list[i].childrens[j].childrens = list[i].childrens[j].siteid_list; // 添加用于树菜单的childrens子级名

            // 处理3级菜单 判断一下是否有childrens节点
            if (list[i].childrens[j].childrens) {
              // 循环第三级数据 添加数据 【排口】
              for (let k = 0; k < list[i].childrens[j].childrens.length; k++) {
                list[i].childrens[j].childrens[k].title = list[i].childrens[j].childrens[k].gkSite_name; // 新添title字段 树菜单显示标题
                list[i].childrens[j].childrens[k].icon = 'icon iconfont icon-yangan'; // 新添icon字段 排口图标
                list[i].childrens[j].childrens[k].parentName = list[i].childrens[j].company_name; // 父节点的名字
                list[i].childrens[j].childrens[k].level = 3; // 添加层级 当前第1层 用于点击事件判断用
                list[i].childrens[j].childrens[k].keyID = '3' + list[i].childrens[j].childrens[k].gkSite_id; // 添加一个唯一ID 用于展开使用；  '3'+ 是为了  1层、2层、3层没有相同的ID
                list[i].childrens[j].childrens[k].keyTime = list[i].childrens[j].time
                  ? parseTime(list[i].childrens[j].time, '{y}')
                  : '';
                list[i].childrens[j].childrens[k].companyId = list[i].childrens[j].company_id;
                // 记录报警排口
                if (this.comids === list[i].childrens[j].company_id) {
                  // 先判断是否传入的当前公司id
                  if (list[i].childrens[j].childrens[k].status === 1) {
                    // 判断当前排口为报警状态
                    _warrSite_ids.push(list[i].childrens[j].childrens[k].gkSite_id); // 记录排口id
                    compayNameList.push(
                      list[i].childrens[j].company_name + ' - ' + list[i].childrens[j].childrens[k].gkSite_name,
                    );
                  }
                }
              }
            }

            // 判断上面记录的 报警排口集合 如果是空的话 代表该公司下没有报警排口 那就默认第一个排口
            if (this.comids === list[i].childrens[j].company_id) {
              // 判断如果传入的公司id 等于 当前2层的公司id
              if (_warrSite_ids.length === 0) {
                _warrSite_ids.push(list[i].childrens[j].siteid_list[0].gkSite_id);
                compayNameList.push(
                  list[i].childrens[j].company_name + ' - ' + list[i].childrens[j].childrens[0].gkSite_name,
                );
                this.createTime = list[i].childrens[j].childrens[0].keyTime;
              }
            }
          }
        }
      }
      this.treeData = list; // 处理好的list赋值树菜单渲染
      let gksiteId = '';
      // // 判断是否 有传入公司ID 代表是首页跳转进来的
      if (this.comids) {
        this.expandedKeys.push('2' + this.$route.params.id); // 展开第2层 公司keyid  默认第1层也会对应展开   '2'+ 是区分是2层
        this.$nextTick(() => {
          // 树菜单 设置选中节点  treeBox 元素的ref
          this.$refs.treeBox.setCurrentKey('3' + _warrSite_ids[0]); // 取报警记录集合中的第1个排口id
        });
        gksiteId = _warrSite_ids[0]; // 取报警记录集合中的第1个排口id
        this.companyName = compayNameList[0]; // 取名字
        this.companyId = this.comids;
      } else {
        // 默认设置第一个公司 节点和选中展开
        if (list[0]) {
          this.expandedKeys.push(list[0].keyID, list[0].childrens[0].keyID); // 展开第一个街道里的第一个公司节点的keyid
          this.$nextTick(() => {
            // 设置选中节点  treeBox 元素的ref
            this.$refs.treeBox.setCurrentKey(list[0].childrens[0].childrens[0].keyID); // 选中第一个排口
          });
          gksiteId = list[0].childrens[0].childrens[0].gkSite_id; // 设置默认 第一个街道 第一个公司 第一个排口id
          this.companyName = list[0].childrens[0].company_name + ' - ' + list[0].childrens[0].childrens[0].gkSite_name;
          this.companyId = list[0].childrens[0].childrens[0].companyId;
          this.createTime = list[0].childrens[0].childrens[0].keyTime;
        }
      }
      this.gkSite_id = gksiteId;
    },
    /**
     * 初始化树菜单数据
     */
    getTreeInfo() {
      const api = this.ApiUrl + 'nowData/findAllZx';
      const data = {
        companyName: this.seachCName || '',
      };
      this.treeLoading = true; // 开启加载动画
      // 请求接口
      this.$http.post(api, data, { emulateJSON: 'application/x-www-form-urlencoded' }).then(
        res => {
          if (res.data.extend.news === 0) {
            var rul = res.data.extend.pageInfo;
            for (var i = rul.length - 1; i >= 0; i--) {
              if (JSON.stringify(rul[i]) == '{}') {
                rul.splice(i, 1);
              }
            }

            this.handleTreeList(rul); // 1.渲染树菜单
            const list = rul;

            if (list.length > 0 && list[0].companylist.length > 0 && list[0].companylist[0].siteid_list.length > 0) {
              this.clickFlag = list[0].companylist[0].siteid_list[0].gkSite_id;
            }

            // this.getYYNowInfo(); // 2.执行【实时数据】
            // this.getYYHistoryInfo(); // 3.执行初始化表格数据 【历史数据】
          }
          this.treeLoading = false; // 开启加载动画
        },
        res => {
          this.treeLoading = false; // 开启加载动画
        },
      );
    },
    /**
     * 树菜单单击事件
     */
    handleNodeClick(data) {
      if (this.gkSite_id != data.gkSite_id * 1 && data.level === 3) {
        this.companyId = data.companyId; //
        this.createTime = data.keyTime;
        this.gkSite_id = data.gkSite_id; // 设置选中排口Id
        this.companyName = data.parentName + ' - ' + data.gkSite_name; // 公司名
      }
    },
    // 刷新页面
    reload() {
      location.reload();
    },
  },
};
</script>
<style lang="scss">
.onlinesystempage {
  .ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }
  .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    padding: 5px 12px 4px;
    font-weight: bold;
  }
  .ivu-tabs-nav .ivu-tabs-tab .ivu-icon {
    margin-right: 4px;
  }
  .ivu-tabs-bar {
    background-color: #fff;
    margin-bottom: 0px;
    border-radius: 8px 8px 0 0;
  }
  .ivu-tabs-nav-container {
    margin-left: 15px;
  }
}
</style>
<style scoped lang="scss">
/deep/ .ivu-badge-count {
  right: -9px !important;
  top: -4px;
  background-color: #ff5b5b;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 16px;
  min-width: 16px;
  padding: 0 4px;
  z-index: 10;
}
</style>
<style scoped lang="scss">
.onlinesystempage {
  padding-left: 15px;
  display: flex;
  overflow: hidden;
  .leftbox {
    flex: 0 0 25%;
    max-width: 25%;
    right: 15px;
    background-color: #fff;
    position: relative;
    padding: 0 15px;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .linehr {
      height: 6px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background-color: #0062ff;
      border-radius: 8px 8px 0 0;
    }
    .treedivbox {
      flex: 1;
      overflow-y: auto;
    }
    // 滚动条宽高
    .treedivbox::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    // 滚动条背景颜色
    .treedivbox::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 5px;
    }
    // 滚动条颜色
    .treedivbox::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
    }
    // 鼠标移动到滚动条上颜色
    .treedivbox::-webkit-scrollbar-thumb:hover {
      background: rgb(122, 121, 121);
    }
  }
  .rightbox {
    flex: 0 0 75%;
    max-width: 75%;
    position: relative;
    overflow: hidden;
    .gsname {
      position: absolute;
      top: 7px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
      color: #0062ff;
      z-index: 10;
    }
    .righttitle {
      display: flex;
      .leftcomname {
        display: flex;
        align-items: center;
        position: relative;
        padding-left: 14px;
        font-size: 16px;
        font-weight: bold;
        line-height: 20px;
        color: #333333;
        margin-right: 21px;
      }
      .leftcomname::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 4px;
        height: 14px;
        background-color: #0062ff;
        transform: translateY(-50%);
      }
      .minutebox,
      .hourbox {
        width: 48px;
        height: 28px;
        background: #fff;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #e5e6ee;
        cursor: pointer;
      }
      .minutebox {
        border-right: none;
        border-radius: 4px 0 0 4px;
      }
      .hourbox {
        border-left: none;
        border-radius: 0 4px 4px 0;
      }
      .timecolor {
        background: #0064ff;
        color: #fff;
      }
    }
    .realtimebox {
      width: 100%;
      background: #ffffff;
      border-radius: 2px;
      margin-top: 15px;
      padding: 15px;
      .realtop {
        display: flex;
        align-items: center;
        .realtext {
          display: flex;
          position: relative;
          padding-left: 14px;
          font-size: 14px;
          font-weight: bold;
          color: #333333;
          margin-right: 30px;
        }
        .realtext::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          width: 4px;
          height: 14px;
          background-color: #0062ff;
          transform: translateY(-50%);
        }
        .timesline {
          display: flex;
          padding: 6px 8px;
          background-color: #0062ff;
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 14px;
          font-weight: bold;
          border-radius: 4px;
          .iconclock {
            font-size: 15px;
            color: #fff;
            margin-right: 5px;
          }
        }
      }
      .realbottom {
        margin-top: 15px;
        display: flex;
        .itemoptbox {
          width: 200px;
          height: 180px;
          background: #f5f5f5;
          padding-top: 15px;
          display: flex;
          flex-direction: column;
          .itemtitle {
            display: flex;
            justify-content: center;
            align-items: center;
            .devicon {
              width: 32px;
              height: 32px;
              border-radius: 50%;
              margin-right: 5px;
            }
            .iconcolor1 {
              background-color: #19be6b;
            }
            .devtext {
              font-size: 16px;
              font-weight: bold;
              color: #333333;
            }
          }
        }
      }
    }
  }
}
.ivu-table {
  font-size: 14px;
}

.topbtn {
  display: flex;
}

.topbtn > div {
  margin-right: 20px;
}

.divday {
  margin-top: 2px;
}

.divday > button {
  margin-right: 5px;
}

.timebox {
  margin-top: 2px;
}

.changbox > button {
  border-radius: 0;
  padding-left: 30px;
  padding-right: 30px;
}

.yyNow {
  padding: 18px 24px;
  background-color: #fafafa;
  border: 1px solid #eaeefb;
  margin-bottom: 25px;
  border-radius: 4px;
  text-align: center;
}

.yyNow i {
  font-size: 36px;
}

.yyNow .ctime {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 12px auto;
  font-size: 14px;
}

.yyDiv {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}

.yyDiv .yyz {
  width: 100%;
  min-width: 1000px;
  flex-shrink: 0;
}

.imgbox {
  padding-top: 2.5rem;
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.imgbox img {
  width: 6.25rem;
  height: 6.25rem;
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-bottom: 20px;
  width: 80%;
}

.comname {
  padding: 10px 0;
  display: block;
  color: #cccccc;
}
.boxStatus {
  width: 100px;
  min-height: 26px;
  color: #fff;
  padding: 2px;
  border-radius: 4px;
  margin: 12px auto;
  font-size: 14px;
  line-height: 26px;
}

.normal {
  background-color: #19be6b;
}

.exceed {
  background-color: #ed4014;
}
.searTime {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  justify-content: flex-end;
}
.searTime > div {
  margin-right: 10px;
}
.btnList {
  height: 37px;
  display: flex;
  flex-wrap: nowrap;
  letter-spacing: 2px;
  justify-content: space-between;
}

.btnList > div {
  display: flex;
}
.btnList > div > div {
  margin-right: 5px;
}
.company_text {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #55a2f2;
}
.ivu-tabs-tab {
  display: flex !important;
  align-items: center !important;
}
</style>
